(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('DownloadDebitNotePDFController',DownloadDebitNotePDFController);

    DownloadDebitNotePDFController.$inject = ['$uibModalInstance'];

    function DownloadDebitNotePDFController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;
        vm.download = download;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function download(status) {
           // Country.delete({id: id},
             //   function () {
                    $uibModalInstance.close(status);
               // });
        }
    }
})();
